import styled from '@emotion/styled';
import { useRef, useEffect } from 'react';
import { Layer } from '../Layer/Layer';
import { renderEngagementZones } from '../../lib/engagementZonesRenderer';
import { registerLayer, unregisterLayer } from '../../lib/heatmapLayersManager';

const Canvas = Layer.withComponent(styled.canvas`
  width: 100%;
`);

interface EngagementLayerProps {
  width: number;
  height: number;
  engagementZones: HeatmapAPI.GetEngagementZonesData | undefined;
  isEngagementZonesActive: boolean;
  heatmapType: HeatmapDataType;
  deviceType: HeatmapDeviceTypes;
}

export const EngagementLayer = ({
  width,
  height,
  engagementZones,
  isEngagementZonesActive,
  heatmapType,
  deviceType,
}: EngagementLayerProps): JSX.Element | null => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (
      isEngagementZonesActive &&
      canvasRef.current &&
      engagementZones !== undefined &&
      engagementZones.engagementGrid.length > 0
    ) {
      renderEngagementZones(canvasRef.current, engagementZones);
    }
  }, [heatmapType, deviceType, isEngagementZonesActive, engagementZones]);

  useEffect(() => {
    registerLayer(canvasRef);

    return () => {
      unregisterLayer(canvasRef);
    };
  }, []);

  return (
    <Canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{ display: isEngagementZonesActive ? 'initial' : 'none' }}
    />
  );
};
